import "./ProductListing.css";

function ProductListing({ products }) {

  return (
    <div className="products-page">

      <aside className="filters">
        <h3>Filters</h3>
      </aside>

      <main className="products-content">

        <div className="sort-row">
          Sort by: Best Selling
        </div>

        <div className="product-grid">

          {products.map((product) => (

            <div
              className="product-card"
              key={product.id}
            >

              {product.saveAmount > 0 && (
                <span className="save-tag">
                  Save {product.saveAmount}
                </span>
              )}

              {product.soldOut && (
                <span className="soldout-tag">
                  Sold Out
                </span>
              )}

              <img
                src={product.imageUrl}
                alt={product.name}
                loading="lazy"
                className="product-image"
              />

              <h4>
                {product.name}
              </h4>

              {product.weight && (
                <div className="weight">
                  {product.weight}
                </div>
              )}

              <div className="price-row">

                <span className="price">
                  ₹ {product.price}
                </span>

                {product.originalPrice >
                  product.price && (
                  <span className="mrp">
                    ₹ {product.originalPrice}
                  </span>
                )}

              </div>

              <button
                disabled={product.soldOut}
                className={
                  product.soldOut
                    ? "soldout-btn"
                    : "cart-btn"
                }
              >
                {product.soldOut
                  ? "Sold Out"
                  : "Add To Cart"}
              </button>

            </div>

          ))}

        </div>

      </main>

    </div>
  );
}

export default ProductListing;